export default __webpack_public_path__ + "static/media/AOT_filled-min.2cd65f0d.png";